import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// ElementUI布局
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import resetMessage from './utils/resetMessage';

Vue.use(ElementUI);

ElementUI.Dialog.props.lockScroll.default = false; // 打开弹窗防止页面抖动

Vue.prototype.$message = resetMessage


// 视频
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video


// Vant
import { createApp } from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload , {
  preLoad: 1.3,
  attempt: 1
})

// 导入富文本编译器
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入富文本编译器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 将富文本编辑器注册为全局可用的组件
Vue.use(VueQuillEditor) 

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
